<template>
  <div class="billing-information-form">
    <div
      v-if="showTitle"
      class="billing-information-title text-secondary"
    >
      {{ $t('payment.billing-information') }}
    </div>

    <validation-observer ref="form">
      <div>
        <b-row>
          <b-col
            sm="12"
            md="6"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('fields.first-name')"
              rules="required"
            >
              <b-form-group
                :label="$t('fields.first-name')"
                label-class="required"
              >
                <b-form-input
                  v-model.trim="billing_address.first_name"
                  :placeholder="$t('fields.first-name')"
                  :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            sm="12"
            md="6"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('fields.last-name')"
              rules="required"
            >
              <b-form-group
                :label="$t('fields.last-name')"
                label-class="required"
              >
                <b-form-input
                  v-model.trim="billing_address.last_name"
                  :placeholder="$t('fields.last-name')"
                  :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            sm="12"
            md="6"
          >
            <b-form-group :label="$t('business.business-name')">
              <b-form-input
                v-model.trim="billing_address.company"
                :readonly="true"
                :placeholder="$t('business.business-name')"
              />
            </b-form-group>
          </b-col>

          <b-col
            sm="12"
            md="6"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('fields.email')"
              rules="required|email"
            >
              <b-form-group
                :label="$t('fields.email')"
                label-class="required"
              >
                <b-form-input
                  v-model.trim="billing_address.email"
                  dir="ltr"
                  :placeholder="$t('fields.email')"
                  :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            sm="12"
            md="6"
          >
            <b-form-group :label="$t('fields.country')">
              <country-select v-model.trim="billing_address.country" />
            </b-form-group>
          </b-col>

          <b-col
            sm="12"
            md="6"
          >
            <b-form-group :label="$t('fields.city')">
              <b-form-input
                v-model.trim="billing_address.city"
                :placeholder="$t('fields.city')"
              />
            </b-form-group>
          </b-col>

          <b-col
            sm="12"
            md="6"
          >
            <b-form-group :label="$t('fields.postcode')">
              <b-form-input
                v-model.trim="billing_address.zip"
                :placeholder="$t('fields.postcode')"
              />
            </b-form-group>
          </b-col>

          <b-col
            v-if="federatedStates.includes(billing_address.country)"
            sm="12"
            md="6"
          >
            <b-form-group :label="$t('fields.state-province')">
              <b-form-input
                v-model.trim="billing_address.state"
                :placeholder="$t('fields.state-province')"
              />
            </b-form-group>
          </b-col>

          <b-col
            sm="12"
            md="12"
          >
            <b-form-group :label="$t('fields.address')">
              <b-form-textarea
                v-model.trim="billing_address.address"
                :placeholder="$t('fields.address')"
                rows="2"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormInput, BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import { mapFields } from 'vuex-map-fields'
import CountrySelect from '@/@okmenu/components/inputs/CountrySelect'
import federatedStates from '@/constants/online-payment/federated-states'

export default {
  name: 'BillingInformationForm',
  components: {
    CountrySelect,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    showTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      federatedStates,
    }
  },
  computed: {
    ...mapFields('purchase', ['billing_address']),
  },
  methods: {
    async validate() {
      return this.$refs.form.validate()
    },
  },
}
</script>

<style lang="scss">
.billing-information-form {
  margin-top: 41px;

  .billing-information-title {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 36px;
  }

}
</style>
